import { shallowEqual, useDispatch, useSelector } from "react-redux";
import styles from "./OverviewShareSave.module.scss";
import OverviewHeartIcon from "@Icons/OverviewHeartIcon";
import OverviewShareIcon from "@Icons/OverviewShareIcon";
import themeVariables from "@Theme/exportColor.module.scss";
import ShortlistButton from "@Pages/Search/components/SearchListItem/components/ShortListButton";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import { AppState } from "@Store/index";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";
import wrapperHOC from "@Utils/wrapperHOC";
import { PAGE } from "constants/configConstants";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useTranslationHook from "hooks/useTranslationHook";
import { getOverviewGalleryEventProps } from "../../utils/galleryEvents";

/**
 * Share and Save at the top right of the breadcrumb row. Same actions as the sidebar icons in
 * PropertyCTAs, which the variant hides.
 */
const OverviewShareSave = () => {
  const dispatch = useDispatch();
  const { t } = useTranslationHook();
  const { data } = useSelector(
    ({ propertyPageData }: AppState) => ({ data: propertyPageData.data }),
    shallowEqual,
  );

  const onShare = () => {
    gtagEventEmitter({
      action: "clicked_share",
      category: PAGE.INVENTORY,
      label: data?.id,
      ...getOverviewGalleryEventProps(),
    });
    new PropertyPageDispatcher(dispatch).showShareModal(true);
  };

  return (
    <div className={styles.actions}>
      <button
        type="button"
        className={styles.pill}
        onClick={onShare}
        data-testid="propertypage-property-share-icon"
      >
        <OverviewShareIcon />
        {t("mischlaneous.share")}
      </button>
      <ShortlistButton
        inventoryId={data?.id}
        inventory={data}
        noAbosolute
        withText
        text={t("Save")}
        eventProps={getOverviewGalleryEventProps()}
        wrapperClassName={styles.pill}
        className={styles.heart}
        // Outline heart; once saved it fills in the brand colour.
        renderIcon={(isSaved) => (
          <OverviewHeartIcon
            filled={isSaved}
            fill={themeVariables.primary4}
            stroke={isSaved ? themeVariables.primary4 : undefined}
          />
        )}
        dataTestId="propertypage-property-shortlist-icon"
        screenName={APP_PAGE.PROPERTY}
      />
    </div>
  );
};

export default wrapperHOC(OverviewShareSave, {
  componentName: "OverviewShareSave-PropertyPage",
  showForChina: true,
  showForWhiteLable: false,
  height: "36px",
});
